import { InputRegexPatterns, MessagingPlacements } from '@MerchantConfigurator/constants/index';

/**
 * Validation function returns boolean value
 */
export const validateMerchantIdentifier = (merchantIdentifier) => {
  // If encrypted account number/payer ID is provided:
  if (merchantIdentifier.length === 13) {
    return validateInputParameter(merchantIdentifier, InputRegexPatterns.encryptedAccountNumber);
  }
  // If merchant client ID is provided:
  return validateInputParameter(merchantIdentifier, InputRegexPatterns.clientId);
};

export const validateInputParameter = (value, pattern) => {
  if (value && typeof value === 'string') {
    //Regular expression for alphanumeric and space
    const regExpression = new RegExp(pattern);

    return regExpression.test(value);
  }
  return false;
};

export const validatePlacements = (placements) => {
  const validPlacements = placements.filter((placement) => {
    return !!MessagingPlacements[placement];
  });

  return validPlacements.length > 0;
};
